// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const woobat: PokeData = {
  "id": 527,
  "name": "woobat",
  "height": 4,
  "weight": 21,
  "base_experience": 65,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "confusion",
    "psychic",
    "amnesia",
    "attract",
    "future-sight",
    "endeavor",
    "imprison",
    "air-cutter",
    "odor-sleuth",
    "calm-mind",
    "assurance",
    "air-slash",
    "simple-beam",
    "heart-stamp"
  ],
  "moves": [
    "gust",
    "psychic",
    "future-sight",
    "calm-mind",
    "air-slash",
    "psychic-terrain",
    "prismatic-cage",
    "psy-pulse",
    "aerial-ace",
    "healing-wish",
    "acrobatics",
    "synchronize",
    "tailwind"
  ],
  "evolution_chain": {
    "id": 269,
    "item": null,
    "species": [
      {
        "name": "woobat",
        "order": 528,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "swoobat",
        "order": 529,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 527,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 54,
    "speed": 72,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
